export default __webpack_public_path__ + "static/media/jefferson.28815e38.webp";